import React from 'react';
import { connect } from 'react-redux';
import { Layout,  Row, Col, Tabs, Tooltip, Icon, Select  } from 'antd';
import {replaceDbValuesForTable, groupBy} from '../../utils/utils';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import TabsRenderProp from '../TabsRenderProp';
import {startSetOverviewTableData, startSetBusinessOverviewData, startSetOverviewChange,
  startSetBusinessOverviewTypeChange, startSetYearChange} from '../../actions/globalState'
import EconomicOverviewTable from './EconomicOverviewTable';
import AboutVariable from '../AboutVariable'
import ChartRenderProp from '../ChartRenderProp'
import { Bar, HorizontalBar } from 'react-chartjs-2';
import {overviewChartOptions, chartData, overviewChartData, chartOverview, makeObjtoArrayTableData, groupReturnedObject} from '../../chart/config';
import EconomicOverviewDropdown from './EconomicOverviewDropdown';
import BusinessOverviewTypeDropdown from './BusinessOverviewTypeDropdown';
import BusinessOverviewYearDropdown from './BusinessOverviewYearDropdown';
import BusinessOverviewTable from './BusinessOverviewTable';

const Option = Select.Option;
const { Header, Footer, Sider, Content } = Layout;
const TabPane = Tabs.TabPane;
const Fragment = React.Fragment;

export class Dashboard extends React.Component {

  onTabChange = (key) => {
    //TODO: This is not good cause it only works for this specific scenario
    // Need to have more general requirements - remove this code cause redux content is stored on clicked on menu
    if (key === '3' || key === '2') {
      //console.log('tab change', key)
      if(this.props.data.data_table.table_ending === 'ep_overviewsummary') {
        this.props.startSetOverviewTableData('ep_overviewtable')
      }
      else if(this.props.data.data_table.table_ending === 'ep_businessoverview') {
        this.props.startSetBusinessOverviewData()
      }
    }
  }
  onEconomicOverviewChange = (text) => {
    this.props.startSetOverviewChange(text);
  }
  onBusinessOverviewTypeChange = (value) => {
    this.props.startSetBusinessOverviewTypeChange(value);
  };
  onBusinessOverviewYearChange = (value) => {
    this.props.startSetYearChange(value);
  };
  render() {
    //console.log('this.props.data.overviewTable', this.props.data)
    const summaryContent = ReactHtmlParser(replaceDbValuesForTable(this.props.data, this.props.data.overviewSummary))
    let chartContent, chartDataInput, table
    if(this.props.data.data_table.table_ending === 'ep_overviewsummary') {
      chartContent = <EconomicOverviewDropdown 
                  overviewChartSelected={this.props.data.overviewChartSelected} 
                  onEconomicOverviewChange={value => this.onEconomicOverviewChange(value)}/>
      chartDataInput = overviewChartData(this.props.data.overviewTable, this.props.data.overviewChartSelected)
      table = <EconomicOverviewTable data={this.props.data.overviewTable}/>
    }
    else if(this.props.data.data_table.table_ending === 'ep_businessoverview') {
      chartContent = <Fragment>
                    <BusinessOverviewTypeDropdown 
                    type={this.props.data.businessOverview.type} 
                    types={this.props.data.businessOverview.types}
                    businessOverviewTypeChange={value => this.onBusinessOverviewTypeChange(value)}/>
                    <BusinessOverviewYearDropdown 
                    year={this.props.data.businessOverview.year}
                    years={this.props.data.businessOverview.years}
                    businessOverviewYearChange={value => this.onBusinessOverviewYearChange(value)}/>
                  </Fragment>
      chartDataInput = chartData(this.props.data.businessOverview.data, 'category', 1, 'type')
      const mainRow = 'category'
      const groupByCategory = groupReturnedObject(this.props.data.businessOverview.table, mainRow, 'type')
      const tableData = makeObjtoArrayTableData(groupByCategory, mainRow)
      //console.log('tableData', tableData)
      table = <Fragment>
                <BusinessOverviewYearDropdown 
                year={this.props.data.businessOverview.year}
                years={this.props.data.businessOverview.years}
                businessOverviewYearChange={value => this.onBusinessOverviewYearChange(value)}/>
                <BusinessOverviewTable data={tableData}/>
              </Fragment>
    }
    return (
      <div className="card-container">
        <Tabs type="card" onChange={value => this.onTabChange(value)}>
          <TabPane tab={<span>Summary 
            <Tooltip title="A quick overview of some of the key features of this variable">
            <Icon type="question-circle"/>
            </Tooltip></span>} key="1">
              <TabsRenderProp 
              header={() => (
                <React.Fragment>{this.props.data.data_table.display_name}</React.Fragment>
              )} 
              content={() => (
                <React.Fragment>
                {summaryContent} 
                </React.Fragment>
              )}
              />
          </TabPane>
          <TabPane tab={<span>Chart 
            <Tooltip title="View and download the data in chart form">
            <Icon type="question-circle" />
            </Tooltip></span>} key="2">
             <ChartRenderProp 
                tableName={this.props.data.data_table.display_name} 
                header = { () => ( 
                  <React.Fragment>{this.props.data.data_table.display_name}</React.Fragment>
                )}
                render = { (setRef) => (
                  <Fragment>
                    {chartContent}
                    <HorizontalBar download={true} redraw={true} 
                      data={chartDataInput} 
                      width={1200}
                      height={550} 
                      options={overviewChartOptions} 
                      ref= {setRef}
                    ></HorizontalBar>
                  </Fragment>
                )} />
          </TabPane>
          <TabPane tab={<span>Table 
            <Tooltip title="View and download the data in tabular form">
            <Icon type="question-circle"/>
            </Tooltip></span>} key="3">
              {table}
          </TabPane> 
          <TabPane tab={<span>About this variable 
            <Tooltip title="Information on how this data has been collected and what it means">
            <Icon type="question-circle" />
            </Tooltip></span>} key="4">
            <AboutVariable data={this.props.data}/>
          </TabPane>
        </Tabs>
      </div>
    )}
};


const mapStateToProps = (state) => ({
  data: state.globalState
});

const mapDispatchToProps = (dispatch) => ({
  startSetOverviewTableData: (text) => dispatch(startSetOverviewTableData(text)),
  startSetBusinessOverviewData: () => dispatch(startSetBusinessOverviewData( )),
  startSetOverviewChange: (text) => dispatch(startSetOverviewChange(text)),
  startSetBusinessOverviewTypeChange: (text) => dispatch(startSetBusinessOverviewTypeChange(text)),
  startSetYearChange: (text) => dispatch(startSetYearChange(text)),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/economicProfile/Dashboard.js